"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./GradientBackground.css");

var _styles = {
  "container": "GradientBackground__container___2yZnG",
  "gradient-layer": "GradientBackground__gradient-layer___1AaBY",
  "noise": "GradientBackground__noise___3x4-i"
};

const styles = _bind.default.bind(_styles);

const GradientBackground = (0, _mobxReact.observer)(({
  className,
  children,
  dataTestId,
  gradient,
  gradientOpacity = 1,
  gradientOffsetTop = 0
}) => {
  const composed_classname = (0, _bind.default)(styles('container'), className);
  const gradient_styles = {
    backgroundImage: gradient,
    opacity: gradientOpacity,
    top: `${gradientOffsetTop}%`
  };
  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: composed_classname
  }, _react.default.createElement("div", {
    className: styles('gradient-layer'),
    style: gradient_styles
  }, _react.default.createElement("div", {
    className: styles('noise')
  }), children));
});
var _default = GradientBackground;
exports.default = _default;